<template>
    <tr :class="['clickable', { disabled: !isActiveBoolAndTime, updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
            <input type="checkbox"
                   :id="entity.id"
                   :value="entity.id"
                   @click.stop
                   @change="onChange"
                   :checked="isChecked"
            />
            <label :for="entity.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td :data-th="'Název' | translate" class="first_data">
            <strong>{{ entity.name }}</strong>
            <span
                    v-if="showClock"
                    class="time"
                    :title="'Časově omezená platnost' | translate"
                    v-translate>Nastavena platnost
			</span>
        </td>
        <td :data-th="'Počet odběratelů' | translate">{{ entity.subscribers_count }}</td>
        <td :data-th="'Počet zařízení' | translate">{{ entity.devices_count }}</td>
        <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
        <td :data-th="'Expirace' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
        <td class="no_padding edit">
            <div class="edit_inner" v-if="!isOperatorMyOperator">
                <a
                        v-if="!isActiveBool && $_updateActionAllowed"
                        class="btn btn_action btn_grey btn_enable"
                        :title="'Aktivovat' | translate"
                        @click.prevent.stop="emitUpdateEntity({active: true})"
                        v-translate>Aktivovat
                </a>
                <a
                        v-if="isActiveBool && $_updateActionAllowed"
                        class="btn btn_action btn_grey btn_disable"
                        :title="'Deaktivovat' | translate"
                        @click.prevent.stop="emitUpdateEntity({active: false})"
                        v-translate>Deaktivovat
                </a>
            </div>
        </td>
    </tr>
</template>

<script>
	import rowActions from "@/components/mixins/row-actions"

	export default {
		name: 'OperatorRow',
		mixins: [rowActions],
		data() {
			return {
				moduleName: 'operators',
				detailPageRouteName: 'operatorDetail',
			}
		},
		computed: {
			isOperatorMyOperator() {
				return String(this.entity.id) === String(this.$store.getters.operatorId)
			},
			isActiveBool() {
				return this.entity.active
			},
			isActiveBoolAndTime() {
				return Boolean(this.isActiveBool && this.entity.is_date_range_active)
			},
			showClock() {
				return Boolean(this.isActiveBool && this.entity.has_any_activation_date)
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/OperatorRow.vue